function Technologies(props) {
  return (
    <>
      <div className="w-auto flex flex-row rounded-lg bg-white justify-center items-center px-1">
        <img className="m-1 sm:h-6 h-4" src={props.Icon} alt="" />
        <div className="mt-1.5 m-0.5 text-sm lg:text-base text-neutral-800 overflow-wrap break-words flex-shrink min-w-0">
          {props.Text}
        </div>
      </div>
    </>
  );
}

export default Technologies;
